module.exports = __webpack_public_path__ + "assets/info-white.1e562035db20b9e7edce578f3bb6e3b9.svg";